/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TranscodedFileRequest } from '../models/TranscodedFileRequest';
import { HttpFile } from '../http/http';

export class TranscodedFilesRequest {
    'hd': TranscodedFileRequest;
    'sd': TranscodedFileRequest;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "hd",
            "baseName": "hd",
            "type": "TranscodedFileRequest",
            "format": ""
        },
        {
            "name": "sd",
            "baseName": "sd",
            "type": "TranscodedFileRequest",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return TranscodedFilesRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

